<template>
  <div>
    <el-form
      ref="TypeFrom"
      :model="typeMod"
      label-position="top"
      label-width="130px"
      size="mini"
      :rules="rules"
    >
      <el-form-item label="类型分类" prop="cateName">
        <a-select
          v-model:value="cateIds"
          mode="multiple"
          show-search
          style="width: 100%"
          placeholder="类型分类"
          :options="options"
          :filter-option="filterOption"
          size="small"
          :max-tag-count="MaxCateSelCount"
        />
      </el-form-item>
      <el-form-item label="类型名称" prop="keyType">
        <el-input v-model="typeMod.keyType"></el-input>
      </el-form-item>
      <el-form-item label="类型状态" prop="state">
        <a-switch
          v-model:checked="typeMod.state"
          checked-children="启用"
          un-checked-children="禁用"
        />
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditTypeComHandle('TypeFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { keytypeEdit } from "@/api/keytype";
export default {
  props: {
    typeMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      MaxCateSelCount: 4,
      rules: {
        keyType: [
          { required: true, message: "请输入类型名称", trigger: "change" },
          { required: true, message: "请输入类型名称", trigger: "blur" },
        ],
      },
      cateIds: [],
    };
  },
  watch: {
    // 监听typeMod的变化，当typeMod.cateIds存在时赋值给内部的cateIds
    "typeMod.cateIds": {
      handler(newVal) {
        // 确保newVal是数组类型
        if (Array.isArray(newVal)) {
          // 使用slice()创建一个新数组，避免直接引用导致的潜在问题
          this.cateIds = newVal.slice();
        } else if (newVal) {
          // 如果是字符串或其他格式，尝试转换为数组
          try {
            this.cateIds = Array.isArray(newVal) ? newVal : [newVal];
          } catch (e) {
            console.error("Failed to parse cateIds:", e);
            this.cateIds = [];
          }
        } else {
          // 如果newVal不存在或为null/undefined，重置为空数组
          this.cateIds = [];
        }
      },
      // 立即执行一次，确保组件初始化时就能正确设置值
      immediate: true,
      // 深度监听对象内部变化
      deep: true,
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    EditTypeComHandle(formName) {
      this.typeMod.cateIds = this.cateIds;
      this.$refs[formName].validate((valid) => {
        keytypeEdit(
          this.typeMod.id,
          this.typeMod.keyType,
          this.typeMod.cateIds,
          this.typeMod.state
        ).then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.$emit("CancleEdit");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    CancleEdit() {
      this.$emit("CancleEdit");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>